(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bd-announcement"] && !Shopify.designMode) return;
  try {
    (()=>{
  const init=root=>{
    root.querySelectorAll('[data-bd-announcement]').forEach(bar=>{
      if(bar.dataset.bdAnnouncementReady)return;
      bar.dataset.bdAnnouncementReady='true';
      const slides=[...bar.querySelectorAll('.bd-announcement__message')];
      const mobile=window.matchMedia('(max-width:749px)');
      let active=0,timer;
      const stop=()=>{clearInterval(timer);timer=undefined;};
      const start=()=>{
        stop();
        if(!mobile.matches||document.hidden||slides.length<2)return;
        timer=setInterval(()=>{
          slides[active].classList.remove('is-active');
          active=(active+1)%slides.length;
          slides[active].classList.add('is-active');
        },5000);
      };
      mobile.addEventListener('change',start);
      document.addEventListener('visibilitychange',start);
      bar.addEventListener('mouseenter',stop);
      bar.addEventListener('mouseleave',start);
      bar.addEventListener('focusin',stop);
      bar.addEventListener('focusout',start);
      document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(bar))stop();});
      start();
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
